// Default Pine Script code for the Tick Volume + POC + CVD indicator
// This is used as the initial seed when no indicators exist in the database

export const DEFAULT_INDICATOR_TITLE = "Tick Volume + POC + CVD";

export const DEFAULT_PINE_SCRIPT = `//@version=6
indicator("Tick Volume + POC + CVD", overlay=true, max_boxes_count=500, max_lines_count=500, max_labels_count=500)

import TradingView/ta/8

// ==========================================
// ==========    BROKER CHECK        ========
// ==========================================
bool isFxOpen = str.contains(str.upper(syminfo.prefix), "FXOPEN")

// ==========================================
// ==========       PDV INPUTS       ========
// ==========================================
grpPDV = "PDV (Volume Zones) - [FXOpen Only]"
showDailyPDV = input.bool(true, "Show Daily PDV (5m)", group=grpPDV)
show1mPDV    = input.bool(false, "Show Daily PDV (1m Refined)", tooltip="Finds the highest 5m volume candle, then marks the highest 1m candle INSIDE it.", group=grpPDV) 
showWeeklyPDV = input.bool(true, "Show Weekly PDV", group=grpPDV)
mitigateOnTouchPDV = input.bool(true, "Infinite & Mitigate Mode", group=grpPDV)
sessEndHourPDV = input.int(42, "Session End Hour (PDV)", group=grpPDV)
sessEndMinutePDV = input.int(0, "Session End Minute (PDV)", group=grpPDV)
dailyBoxColorPDV = input.color(color.new(#dbdbdb, 40), "Daily Color (5m)", group=grpPDV)
pdv1mColor       = input.color(color.new(#dbdbdb, 40), "Daily Color (1m)", group=grpPDV) 
weeklyBoxColorPDV = input.color(color.new(#b2ebf2, 70), "Weekly Color", group=grpPDV) 
borderColorPDV = input.color(color.new(#ffffff, 48), "Border Color", group=grpPDV)
enableAlertsPDV = input.bool(true, "Enable PDV Alerts", group=grpPDV)
alertMsgPDV = input.string("Price touched High Vol Zone", "Alert Message", group=grpPDV)

// ==========================================
// ==========     POC INPUTS         ========
// ==========================================
grpPOC = "Daily POC Line"
showPOC = input.bool(true, "Show Daily POC", group=grpPOC)
pocColor = input.color(color.new(color.orange, 30), "POC Color", group=grpPOC)
pocWidth = input.int(2, "POC Width", minval=1, maxval=5, group=grpPOC)
pocStyle = input.string("solid", "POC Style", options=["solid", "dashed", "dotted"], group=grpPOC)
showActivePOC = input.bool(true, "Show Active (Live) POC", group=grpPOC)
activePocColor = input.color(color.new(color.lime, 30), "Active POC Color", group=grpPOC)
activePocWidth = input.int(2, "Active POC Width", minval=1, maxval=5, group=grpPOC)
activePocStyle = input.string("dashed", "Active POC Style", options=["solid", "dashed", "dotted"], group=grpPOC)

// ==========================================
// ==========   SESSION TIME INPUTS  ========
// ==========================================
grpSess = "Session Time Settings"
useNYSession = input.bool(false, "Use New York Session", tooltip="When enabled, all PDV, POC, CVD and daily volume calculations use midnight-to-midnight New York time (America/New_York, DST aware). Default uses 02:00-01:00 GMT+3 (Africa/Nairobi or equivalent, DST aware).", group=grpSess)

// Session boundaries for day detection
// Default: 02:00 to 01:00 next day in GMT+3 (covers full trading day)
// NY Mode: 00:00 to 23:59 in America/New_York (midnight to midnight ET)
string sessionStr = useNYSession ? "0000-2359" : "0200-0100"
string sessTZ = useNYSession ? "America/New_York" : "Etc/GMT-3"

// ==========================================
// ==========   1 MIN MAX VOL INPUTS   ======
// ==========================================
grp1m = "1 Minute Max Vol Box (Current Day) - [FXOpen Only]"
show1mBox = input.bool(true, "Show 1m High Vol Box", group=grp1m)
volThreshold = input.int(1, "Min Volume Threshold", group=grp1m)
sessEndHour1m = 16 
col1mBox  = input.color(color.new(color.yellow, 80), "Box Color", group=grp1m)
bor1mBox  = input.color(color.new(color.yellow, 50), "Border Color", group=grp1m)

// ==========================================
// ==========       CVD INPUTS       ========
// ==========================================
grpCVD = "Cumulative Volume Delta (CVD) - [FXOpen Only]"
showCVD = input.bool(true, "Show CVD Dashboard", group=grpCVD)
cvdPos  = input.string("Top Right", "Position", options=["Top Right", "Bottom Right", "Top Left", "Bottom Left"], group=grpCVD)
cvdSize = input.string("Tiny", "Size", options=["Tiny", "Small", "Normal", "Large"], group=grpCVD)
cvdTextColor = input.color(color.rgb(2, 2, 2), "Text Color", group=grpCVD)

// Advanced CVD Logic Inputs
anchorInputDaily = input.timeframe("1D", "CVD Daily Reset", group=grpCVD)
anchorInputWeekly = input.timeframe("1W", "CVD Weekly Reset", group=grpCVD)
anchorInputMonthly = input.timeframe("1M", "CVD Monthly Reset", group=grpCVD)
useCustomTimeframeInput = input.bool(false, "Use Custom CVD Timeframe", tooltip="By default, the indicator selects the best lower timeframe. Enable this to force a specific one.", group=grpCVD)
lowerTimeframeInput = input.timeframe("1", "Custom Timeframe", active = useCustomTimeframeInput, group=grpCVD)


// ====================================================================
// ====================    SESSION HELPERS     ========================
// ====================================================================

// Detect custom session day change (respects GMT+3 or NY timezone)
isSessionNewDay = ta.change(time("D", sessionStr, sessTZ)) != 0
isSessionNewWeek = ta.change(time("W")) != 0


// ====================================================================
// ====================        PDV LOGIC         ======================
// ====================================================================

// --- Custom Function for 5m Data ---
type VolStats
    float maxVol
    float top
    float bot
    int   loc
    int   locClose

f_calc_period_stats(bool isNewPeriod) =>
    var float p_maxVol = 0.0
    var float p_high   = na
    var float p_low    = na
    var int   p_time   = na
    var int   p_close  = na
    
    if isNewPeriod
        p_maxVol := 0.0
        p_high   := na
        p_low    := na
        p_time   := na
        p_close  := na
    
    if volume > p_maxVol
        p_maxVol := volume
        p_high   := high
        p_low    := low
        p_time   := time
        p_close  := time_close
        
    [p_maxVol, p_high, p_low, p_time, p_close]

// --- Custom Function for Refined 1m Data ---
f_calc_refined_1m() =>
    var float cur_5m_sum_vol = 0.0
    var float cur_best_1m_vol = 0.0
    var float cur_best_1m_h = na
    var float cur_best_1m_l = na
    var int   cur_best_1m_t = na
    var float day_max_5m_vol = 0.0
    var float day_refined_h = na
    var float day_refined_l = na
    var int   day_refined_t = na

    bool isNewDay = ta.change(time("D", sessionStr, sessTZ)) != 0
    bool isNew5m  = ta.change(time("5")) != 0

    if isNewDay
        day_max_5m_vol := 0.0
        day_refined_h  := na
        day_refined_l  := na
        day_refined_t  := na
        cur_5m_sum_vol := 0.0
        cur_best_1m_vol := 0.0
        cur_best_1m_h  := na
        cur_best_1m_l  := na
        cur_best_1m_t  := na

    if isNew5m and not isNewDay
        cur_5m_sum_vol := 0.0
        cur_best_1m_vol := 0.0
        cur_best_1m_h  := na
        cur_best_1m_l  := na
        cur_best_1m_t  := na

    cur_5m_sum_vol += volume
    
    if volume > cur_best_1m_vol
        cur_best_1m_vol := volume
        cur_best_1m_h   := high
        cur_best_1m_l   := low
        cur_best_1m_t   := time
        
    if cur_5m_sum_vol > day_max_5m_vol
        day_max_5m_vol := cur_5m_sum_vol
        day_refined_h  := cur_best_1m_h
        day_refined_l  := cur_best_1m_l
        day_refined_t  := cur_best_1m_t
        
    [day_refined_h, day_refined_l, day_refined_t]

// Get Data (using session-aware day detection)
[d_vol, d_high, d_low, d_time, d_close] = request.security(syminfo.tickerid, "5", f_calc_period_stats(ta.change(time("D", sessionStr, sessTZ)) != 0), lookahead=barmerge.lookahead_off)
[d1m_high, d1m_low, d1m_time] = request.security(syminfo.tickerid, "1", f_calc_refined_1m(), lookahead=barmerge.lookahead_off)
[w_vol, w_high, w_low, w_time, w_close] = request.security(syminfo.tickerid, "5", f_calc_period_stats(ta.change(time("W")) != 0), lookahead=barmerge.lookahead_off)

// Storage
var box[] activeBoxesPDV = array.new_box()

// Drawing Logic
isChartNewDay = isSessionNewDay
isChartNewWeek = isSessionNewWeek

get_box_props_pdv() =>
    int targetEnd = timestamp(year(time), month(time), dayofmonth(time), sessEndHourPDV, sessEndMinutePDV, 0)
    if not mitigateOnTouchPDV and dayofweek == dayofweek.friday
        targetEnd := timestamp(year(time), month(time), dayofmonth(time) + 3, sessEndHourPDV, sessEndMinutePDV, 0)
    string ext = mitigateOnTouchPDV ? extend.right : extend.none
    int r_coord = mitigateOnTouchPDV ? time : targetEnd
    [ext, r_coord]

if isFxOpen and isChartNewDay
    if showDailyPDV
        float prevDayVol   = d_vol[1]
        float prevDayHigh  = d_high[1]
        float prevDayLow   = d_low[1]
        int   prevDayTime  = d_time[1]
        if not na(prevDayVol) and prevDayVol > 0
            [extType, rightCoord] = get_box_props_pdv()
            box newBox = box.new(left=prevDayTime, right=rightCoord, top=prevDayHigh, bottom=prevDayLow, bgcolor=dailyBoxColorPDV, border_color=borderColorPDV, xloc=xloc.bar_time, extend=extType)
            array.push(activeBoxesPDV, newBox)

    if show1mPDV
        float prevRefHigh = d1m_high[1]
        float prevRefLow  = d1m_low[1]
        int   prevRefTime = d1m_time[1]
        if not na(prevRefHigh)
            [extType1m, rightCoord1m] = get_box_props_pdv()
            box newBox1m = box.new(left=prevRefTime, right=rightCoord1m, top=prevRefHigh, bottom=prevRefLow, bgcolor=pdv1mColor, border_color=borderColorPDV, xloc=xloc.bar_time, extend=extType1m)
            array.push(activeBoxesPDV, newBox1m)

if isFxOpen and isChartNewWeek and showWeeklyPDV
    float prevWeekVol  = w_vol[1]
    float prevWeekHigh = w_high[1]
    float prevWeekLow  = w_low[1]
    int   prevWeekTime = w_time[1]
    if not na(prevWeekVol) and prevWeekVol > 0
        int weekNormalEnd = timestamp(year(time), month(time), dayofmonth(time) + 6, sessEndHourPDV, sessEndMinutePDV, 0)
        string wExt = mitigateOnTouchPDV ? extend.right : extend.none
        int wRight = mitigateOnTouchPDV ? time : weekNormalEnd
        box newBox = box.new(left=prevWeekTime, right=wRight, top=prevWeekHigh, bottom=prevWeekLow, bgcolor=weeklyBoxColorPDV, border_color=borderColorPDV, xloc=xloc.bar_time, extend=wExt)
        array.push(activeBoxesPDV, newBox)

if isFxOpen and mitigateOnTouchPDV and array.size(activeBoxesPDV) > 0
    for i = array.size(activeBoxesPDV) - 1 to 0
        box b = array.get(activeBoxesPDV, i)
        float bTop = box.get_top(b)
        float bBot = box.get_bottom(b)
        int   bLeft = box.get_left(b)
        bool isTouched = (high >= bBot and low <= bTop)
        bool isDifferentDay = dayofmonth(time) != dayofmonth(bLeft) or month(time) != month(bLeft) or year(time) != year(bLeft)
        if isTouched and isDifferentDay
            if enableAlertsPDV
                alert(alertMsgPDV, alert.freq_once_per_bar_close)
            box.set_extend(b, extend.none)
            box.set_right(b, time)
            array.remove(activeBoxesPDV, i)

if (not isFxOpen or not mitigateOnTouchPDV) and array.size(activeBoxesPDV) > 0
    array.clear(activeBoxesPDV)


// ====================================================================
// ====================    DAILY POC LINE    ==========================
// ====================================================================

// True Volume Profile POC matching FRVP exactly.
// Stores each session bar's OHLCV, then recomputes a 24-row profile
// (same as FRVP "Number of Rows = 24") on every bar using the
// current session high/low. This ensures identical row boundaries.

int VP_ROWS = 24
var float[] vpBarHigh = array.new_float()
var float[] vpBarLow  = array.new_float()
var float[] vpBarVol  = array.new_float()
var float vpSessHigh = na
var float vpSessLow  = na

if isSessionNewDay
    array.clear(vpBarHigh)
    array.clear(vpBarLow)
    array.clear(vpBarVol)
    vpSessHigh := high
    vpSessLow  := low

if not isSessionNewDay
    if high > nz(vpSessHigh, high)
        vpSessHigh := high
    if low < nz(vpSessLow, low)
        vpSessLow := low

// Store current bar data
array.push(vpBarHigh, high)
array.push(vpBarLow, low)
array.push(vpBarVol, nz(volume))

// Recompute 24-row volume profile from all session bars
float vpPocPrice = na
float vpRange = nz(vpSessHigh) - nz(vpSessLow)
if vpRange > 0 and array.size(vpBarHigh) > 0
    float rowSize = vpRange / VP_ROWS
    var float[] rowVol = array.new_float(VP_ROWS, 0.0)
    for r = 0 to VP_ROWS - 1
        array.set(rowVol, r, 0.0)
    
    int nBars = array.size(vpBarHigh)
    for b = 0 to nBars - 1
        float bH = array.get(vpBarHigh, b)
        float bL = array.get(vpBarLow, b)
        float bV = array.get(vpBarVol, b)
        if bV > 0
            int rowStart = math.max(0, int(math.floor((bL - vpSessLow) / rowSize)))
            int rowEnd   = math.min(VP_ROWS - 1, int(math.floor((bH - vpSessLow) / rowSize)))
            if rowEnd < rowStart
                rowEnd := rowStart
            int rowCount = rowEnd - rowStart + 1
            float vPerRow = bV / rowCount
            for r = rowStart to rowEnd
                array.set(rowVol, r, array.get(rowVol, r) + vPerRow)
    
    // Find POC row
    float pocMaxVol = 0.0
    int pocRow = 0
    for r = 0 to VP_ROWS - 1
        float rv = array.get(rowVol, r)
        if rv > pocMaxVol
            pocMaxVol := rv
            pocRow := r
    
    // POC price = center of the winning row
    vpPocPrice := vpSessLow + (pocRow + 0.5) * rowSize

// Drawing Logic
var line[] activePOCLines = array.new_line()

pocLineStyle = pocStyle == "solid" ? line.style_solid : pocStyle == "dashed" ? line.style_dashed : line.style_dotted
activePocLineStyle = activePocStyle == "solid" ? line.style_solid : activePocStyle == "dashed" ? line.style_dashed : line.style_dotted

// --- Active (Live) POC: true volume profile POC updated in real-time ---
var line activePocLine = na

// On new session day: finalize yesterday's POC as a previous day POC line
if isFxOpen and showPOC and isSessionNewDay
    if not na(activePocLine)
        float prevActivePocY = line.get_y1(activePocLine)
        int   prevActivePocX = line.get_x1(activePocLine)
        line.set_extend(activePocLine, extend.none)
        line.set_x2(activePocLine, time)
        line pocLine = line.new(x1=prevActivePocX, y1=prevActivePocY, x2=time, y2=prevActivePocY, xloc=xloc.bar_time, color=pocColor, width=pocWidth, style=pocLineStyle, extend=extend.right)
        array.push(activePOCLines, pocLine)
    activePocLine := na

// Update active POC throughout the day using volume profile POC price
if isFxOpen and showActivePOC and not na(vpPocPrice)
    if na(activePocLine)
        activePocLine := line.new(x1=time, y1=vpPocPrice, x2=time, y2=vpPocPrice, xloc=xloc.bar_time, color=activePocColor, width=activePocWidth, style=activePocLineStyle, extend=extend.right)
    else
        line.set_y1(activePocLine, vpPocPrice)
        line.set_y2(activePocLine, vpPocPrice)
        line.set_x2(activePocLine, time)

// Mitigate previous day POC lines when price touches them
if isFxOpen and showPOC and array.size(activePOCLines) > 0
    for i = array.size(activePOCLines) - 1 to 0
        line l = array.get(activePOCLines, i)
        float pocY = line.get_y1(l)
        int   pocX = line.get_x1(l)
        bool isTouched = (high >= pocY and low <= pocY)
        bool isDiffDay = dayofmonth(time) != dayofmonth(pocX) or month(time) != month(pocX) or year(time) != year(pocX)
        if isTouched and isDiffDay
            line.set_extend(l, extend.none)
            line.set_x2(l, time)
            array.remove(activePOCLines, i)


// ====================================================================
// ====================    1 MIN MAX VOLUME BOX    ====================
// ====================================================================

f_track_1m_max(float thresh) =>
    var float d_max_vol = 0.0
    var float d_high2 = na
    var float d_low2 = na
    var int d_time2 = na
    if ta.change(time("D", sessionStr, sessTZ)) != 0
        d_max_vol := 0.0
        d_high2 := na
        d_low2 := na
        d_time2 := na
    float vol = nz(volume)
    if vol >= d_max_vol and vol >= thresh
        d_max_vol := vol
        d_high2 := high
        d_low2 := low
        d_time2 := time
    [d_high2, d_low2, d_time2]

[m1High, m1Low, m1Time] = request.security(syminfo.tickerid, "1", f_track_1m_max(volThreshold))

var box box1m = na

if isChartNewDay
    box.delete(box1m)
    box1m := na

if isFxOpen and show1mBox and not na(m1Time) and dayofmonth(m1Time) == dayofmonth(time)
    int eodTime = time_close("D")
    if na(box1m)
        box1m := box.new(left=m1Time, top=m1High, right=eodTime, bottom=m1Low, bgcolor=col1mBox, border_color=bor1mBox, xloc=xloc.bar_time)
    else
        box.set_left(box1m, m1Time)
        box.set_top(box1m, m1High)
        box.set_bottom(box1m, m1Low)
        box.set_right(box1m, eodTime)


// ====================================================================
// ====================    CVD (Daily + Weekly + Monthly)    ==========
// ====================================================================

var lowerTimeframe = switch
    useCustomTimeframeInput => lowerTimeframeInput
    timeframe.isseconds     => "1S"
    timeframe.isintraday    => "1"
    timeframe.isdaily       => "5"
    => "60"

// Calculate CVD for Daily, Weekly, Monthly
[openVolD, maxVolD, minVolD, lastVolD] = ta.requestVolumeDelta(lowerTimeframe, anchorInputDaily)
[openVolW, maxVolW, minVolW, lastVolW] = ta.requestVolumeDelta(lowerTimeframe, anchorInputWeekly)
[openVolM, maxVolM, minVolM, lastVolM] = ta.requestVolumeDelta(lowerTimeframe, anchorInputMonthly)

// Display Table (CVD row/column layout)
// Columns: CVD | Direction | Value
// Rows: Header, Daily, Weekly, Monthly
var table cvdTable = table.new(position.bottom_right, 3, 4, border_width=1)

if isFxOpen and showCVD
    string posInput = cvdPos
    string t_pos = position.bottom_right
    if posInput == "Top Right"
        t_pos := position.top_right
    else if posInput == "Top Left"
        t_pos := position.top_left
    else if posInput == "Bottom Left"
        t_pos := position.bottom_left

    string sizeInput = cvdSize
    string t_size = size.normal
    if sizeInput == "Tiny"
        t_size := size.tiny
    else if sizeInput == "Small"
        t_size := size.small
    else if sizeInput == "Large"
        t_size := size.large

    table.set_position(cvdTable, t_pos)

    // Header Row
    table.cell(cvdTable, 0, 0, "CVD", bgcolor=color.new(color.gray, 85), text_color=color.gray, text_size=t_size)
    table.cell(cvdTable, 1, 0, "Direction", bgcolor=color.new(color.gray, 85), text_color=color.gray, text_size=t_size)
    table.cell(cvdTable, 2, 0, "Value", bgcolor=color.new(color.gray, 85), text_color=color.gray, text_size=t_size)

    // Daily Row
    color colD = lastVolD >= 0 ? color.green : color.red
    string dirD = lastVolD >= 0 ? "Bullish" : "Bearish"
    table.cell(cvdTable, 0, 1, "Daily", bgcolor=color.new(color.gray, 90), text_color=color.gray, text_size=t_size)
    table.cell(cvdTable, 1, 1, dirD, bgcolor=color.new(colD, 80), text_color=colD, text_size=t_size)
    table.cell(cvdTable, 2, 1, str.tostring(lastVolD, format.volume), bgcolor=color.new(color.gray, 90), text_color=cvdTextColor, text_size=t_size)

    // Weekly Row
    color colW = lastVolW >= 0 ? color.green : color.red
    string dirW = lastVolW >= 0 ? "Bullish" : "Bearish"
    table.cell(cvdTable, 0, 2, "Weekly", bgcolor=color.new(color.gray, 90), text_color=color.gray, text_size=t_size)
    table.cell(cvdTable, 1, 2, dirW, bgcolor=color.new(colW, 80), text_color=colW, text_size=t_size)
    table.cell(cvdTable, 2, 2, str.tostring(lastVolW, format.volume), bgcolor=color.new(color.gray, 90), text_color=cvdTextColor, text_size=t_size)

    // Monthly Row
    color colM = lastVolM >= 0 ? color.green : color.red
    string dirM = lastVolM >= 0 ? "Bullish" : "Bearish"
    table.cell(cvdTable, 0, 3, "Monthly", bgcolor=color.new(color.gray, 90), text_color=color.gray, text_size=t_size)
    table.cell(cvdTable, 1, 3, dirM, bgcolor=color.new(colM, 80), text_color=colM, text_size=t_size)
    table.cell(cvdTable, 2, 3, str.tostring(lastVolM, format.volume), bgcolor=color.new(color.gray, 90), text_color=cvdTextColor, text_size=t_size)
else
    table.clear(cvdTable, 0, 0, 2, 3)

plot(na, title="End", display=display.none)`;
